import React, { useContext } from "react";
import { HotelContext } from "../../../context/HotelContext";
import { translate } from "../../../utils/Translation";
import LoadingIndicator from "./LoadingIndicator";
import "./SalesByTypeTable.css";
import SpaIcon from "../../../img/v2/spa-icon.svg";
import ShopIcon from "../../../img/v2/shop-icon.svg";

const SalesByTypeTable = ({
  title = "",
  subtitle = "",
  data = [],
  loading = false,
  className = "",
}) => {
  const { lang } = useContext(HotelContext);

  const getIcon = (name) => {
    if (!name) return null;
    const nameLower = name.toLowerCase();
    if (nameLower.includes("spa")) {
      return <img src={SpaIcon} alt="Spa" className="sales-by-type-table__icon-img" />;
    }
    return <img src={ShopIcon} alt="Shop" className="sales-by-type-table__icon-img" />;
  };

  if (loading) {
    return (
      <div className={`sales-by-type-table ${className}`}>
        <div className="sales-by-type-table__header">
          {title && <h3 className="sales-by-type-table__title">{title}</h3>}
          {subtitle && <p className="sales-by-type-table__subtitle">{subtitle}</p>}
        </div>
        <div className="sales-by-type-table__content">
          <LoadingIndicator />
        </div>
      </div>
    );
  }

  return (
    <div className={`sales-by-type-table ${className}`}>
      <div className="sales-by-type-table__header">
        {title && <h3 className="sales-by-type-table__title">{title}</h3>}
        {subtitle && <p className="sales-by-type-table__subtitle">{subtitle}</p>}
      </div>
      <div className="sales-by-type-table__content">
        {data && data.length > 0 ? (
          <>
            <div className="sales-by-type-table__table-header">
              <div className="sales-by-type-table__header-cell sales-by-type-table__header-cell--name">
                {translate("v2_sales_product_name", lang)}
              </div>
              <div className="sales-by-type-table__header-cell sales-by-type-table__header-cell--usage">
                {translate("v2_sales_usage_count", lang)}
              </div>
              <div className="sales-by-type-table__header-cell sales-by-type-table__header-cell--per-sale">
                {translate("v2_sales_upsales_per_sale", lang)}
              </div>
              <div className="sales-by-type-table__header-cell sales-by-type-table__header-cell--total">
                {translate("v2_sales_upsales_total", lang)}
              </div>
            </div>

            <div className="sales-by-type-table__table-body">
              {data.map((row, index) => (
                <React.Fragment key={index}>
                  <div className="sales-by-type-table__row">
                    <div className="sales-by-type-table__cell sales-by-type-table__cell--name">
                      <div className="sales-by-type-table__icon">
                        {getIcon(row.name) || (
                          <div
                            className="sales-by-type-table__icon-fallback"
                            style={{ backgroundColor: row.iconColor || "#91B0D8" }}
                          />
                        )}
                      </div>
                      <span className="sales-by-type-table__name">{row.name}</span>
                    </div>
                    <div className="sales-by-type-table__cell sales-by-type-table__cell--usage">{row.usageCount}</div>
                    <div className="sales-by-type-table__cell sales-by-type-table__cell--per-sale">{row.upsalesPerSale}</div>
                    <div className="sales-by-type-table__cell sales-by-type-table__cell--total">{row.totalUpsales}</div>
                  </div>
                  {index < data.length - 1 && <div className="sales-by-type-table__separator" />}
                </React.Fragment>
              ))}
            </div>
          </>
        ) : (
          <div className="sales-by-type-table__empty">{translate("v2_no_data", lang)}</div>
        )}
      </div>
    </div>
  );
};

export default SalesByTypeTable;
